import { render } from "./SocialMediaPostAdd.vue?vue&type=template&id=b8f4223e"
import script from "./SocialMediaPostAdd.vue?vue&type=script&lang=js"
export * from "./SocialMediaPostAdd.vue?vue&type=script&lang=js"

import "./SocialMediaPostAdd.vue?vue&type=style&index=0&id=b8f4223e&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__